import { Box, IconButton, Tooltip } from '@mui/material';
import { EditIcon, Focus, Settings } from 'lucide-react';
import { useRecoilState } from 'recoil';
import { openedROIPropertiesOverlayState } from '~/state/atoms/structureSet/roiAtoms';

export default function StructureActions({
    onEdit,
    onFocus,
    isEditable,
}: {
    onEdit: () => void;
    onFocus: () => void;
    isEditable: boolean;
}) {
    const [visibleRoiProperties, setVisibleRoiProperties] = useRecoilState(
        openedROIPropertiesOverlayState
    );
    const handleOpenROIProperties = () => {
        setVisibleRoiProperties(!visibleRoiProperties);
    };

    return (
        <Box
            display="flex"
            className="buttons"
            sx={{
                visibility: 'hidden',
            }}
        >
            <Tooltip
                title={isEditable ? 'Edit name' : `Structure already reviewed`}
                enterDelay={500}
                enterNextDelay={500}
            >
                <div>
                    <IconButton
                        color="primary"
                        size="small"
                        onClick={onEdit}
                        disabled={!isEditable}
                    >
                        <EditIcon size={12} />
                    </IconButton>
                </div>
            </Tooltip>

            <Tooltip title={'Focus'} enterDelay={500} enterNextDelay={500}>
                <IconButton color="primary" size="small" onClick={onFocus}>
                    <Focus size={12} />
                </IconButton>
            </Tooltip>
            <Tooltip title={'Properties'} enterDelay={500} enterNextDelay={500}>
                <IconButton
                    color="primary"
                    size="small"
                    onClick={handleOpenROIProperties}
                    data-testid="roi-properties-button"
                >
                    <Settings size={12} />
                </IconButton>
            </Tooltip>
        </Box>
    );
}
